const networkStatus: any = () => ({
  401: 'UnAuthorized',
  404: 'API Route is Missing or Undefined',
  405: 'API Route Method Not Allowed',
  422: 'Unprocessable Entity',
  /** TODO: on handleStatus500 function call the specs are failing,
   *  we need to to make the function common and use it here , instead of calling in all files ,
   * will be done in future releasees */
})

const axiosResponseHandler = (response: any) => {
  //Todo : add if anything needs to be done over a response
  return response
}

const axiosErrorHandler = (error: any) => {
  if (typeof error.response !== 'undefined') {
    {
      /** networkStatus(error)[error?.response?.status] =>  will pass the error to specific function within the hash,
       *  for example if 422 has errorFunction(error) as a value, it will get executed,
       *  for the time being we have kept error msgs for the status codes,
       *  This will help to call the error functions at single place (@here), instead of calling it in catch for each api
       */
    }
    networkStatus()[error?.response?.status]
  }

  return Promise.reject(error)
}

const responseHandler = { axiosErrorHandler, axiosResponseHandler }

export default responseHandler
